import { render } from "./UserIndex.vue?vue&type=template&id=f61d4600&scoped=true"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"

import "./UserIndex.vue?vue&type=style&index=0&id=f61d4600&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61d4600"]])

export default __exports__